import api from './api';

class EvaluacionDetalladaApi {
    static async createEvaluacionDetallada(evaluacionData) {
        return api.post('/evaluacion-detallada', evaluacionData, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async getEvaluacionDetallada(id) {
        return api.get(`/evaluacion-detallada/${id}`);
    }

    static async getEvaluacionByReclutamiento(reclutamientoId) {
        return api.get(`/evaluacion-detallada/reclutamiento/${reclutamientoId}`);
    }
}

export default EvaluacionDetalladaApi; 